import React from 'react';
import { SpinnerLoader } from './styled';

export default function AddItemLoader() {
  return (
    <SpinnerLoader>
      <span className="smooth spinner" />
    </SpinnerLoader>
  );
}
